import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomerService, Customer } from 'gung-standard';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomerService extends CustomerService {
  private customersSubjects: ReplaySubject<Customer[]>;
  private currentCustomerSubject: ReplaySubject<Customer> = new ReplaySubject<Customer>();
  private currentCustomerObservable: Observable<Customer> = this.currentCustomerSubject.asObservable();

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getCustomers(noCache?: boolean): Observable<Customer[]> {
    if (!this.customersSubjects) {
      this.customersSubjects = new ReplaySubject<Customer[]>();
    }
    this.updateCustomersSubject(noCache);
    return this.customersSubjects.asObservable();
  }

  updateCustomersSubject(noCache?: boolean): void {
    this.internalGetCustomersFromUrl(noCache).subscribe((c: Customer[]) => this.customersSubjects.next(c));
  }

  protected internalGetCustomersFromUrl(noCache?: boolean): Observable<Customer[]> {
    const url = 'json/customers';
    const headers: { [key: string]: string | string[] } = {};
    if (noCache) {
      headers.maxAge = '-1';
    }
    return this.httpClient.get<Customer[]>(url, { headers });
  }

  getCustomerBySubject(customerId: string) {
    this.internalGetCustomerFromUrl(customerId).subscribe((c: Customer) => {
      this.currentCustomerSubject.next(c);
    });

    return this.currentCustomerObservable;
  }

  updateCurrentCustomerSubject(customerId: string, noCache?: boolean): void {
    this.internalGetCustomerFromUrl(customerId, noCache).subscribe((c: Customer) => {
      this.currentCustomerSubject.next(c);
    });
  }

  protected internalGetCustomerFromUrl(customerId: string, noCache?: boolean): Observable<Customer> {
    const url = 'json/customers/' + customerId;
    const headers: { [key: string]: string | string[] } = {};
    if (noCache) {
      headers.maxAge = '-1';
    }
    return this.httpClient.get<Customer>(url, { headers });
  }
}
